export default "__VITE_ASSET__P40oDO9r__"